<template lang="pug">
  .code-config-select
    v-select(:value="selectedOption" @input="onInput" :options="options" label="name" :placeholder="loading ? 'Loading ...' : placeholder" :disabled="disabled")
</template>

<script>
import vSelect from 'vue-select'
import Core from '@/service/apis/Core'

export default {
  props: {
    value: {
      type: Number,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    withGlobalConfigs: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data: () => ({
    loading: false,
    options: [],
    placeholder: 'Select Code Configuration',
    selectedOption: null,
  }),
  created() {
    this.loading = true
    Core.getCodeConfigurations({ size: 1000 })
      .then((resp) => {
        const options = resp.data.content
        if (!this.withGlobalConfigs) {
          options.splice(0, 2) // removes the global configs
        }
        this.options = options
        this.updateSelectedOption()
      })
      .catch((e) => {
        this.placeholder = e.response.data.message
      })
      .then(() => {
        this.loading = false
      })
  },
  methods: {
    updateSelectedOption() {
      if (this.value) {
        this.selectedOption = this.options.find((o) => o.id === this.value)
      } else {
        this.selectedOption = null
      }
    },
    onInput(val) {
      this.$emit('input', val ? val.id : null)
    },
    getSelectedAtiGroup() {
      return this.selectedOption
    }
  },
  watch: {
    value() {
      this.updateSelectedOption()
    }
  },
  components: {
    vSelect
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ssp/CodeConfigSelect.vue